import { useState } from "react";
import { SmallSelector } from "../../components";
import { IUser } from "../../models";
import dayjs from "dayjs";
import {
  MonthlyCaloriesOutChart,
  MonthlyDeficitChart,
  MonthlyIntakeChart,
} from "..";
import styles from "./styles.module.scss";

const CalorieCharts = ({ date, user }: { date: dayjs.Dayjs; user: IUser }) => {
  const [selectedChart, setSelectedChart] = useState<
    "Calorie In" | "Calorie Out" | "Calorie Deficit"
  >("Calorie Deficit");

  return (
    <div className={styles.wrapper}>
      <SmallSelector
        data={["Calorie Deficit", "Calorie In", "Calorie Out"]}
        value={selectedChart}
        setValue={(value) =>
          setSelectedChart(
            value as "Calorie In" | "Calorie Out" | "Calorie Deficit"
          )
        }
      />
      {selectedChart === "Calorie Deficit" ? (
        <MonthlyDeficitChart user={user} date={date} />
      ) : selectedChart === "Calorie In" ? (
        <MonthlyIntakeChart user={user} date={date} />
      ) : (
        <MonthlyCaloriesOutChart user={user} date={date} />
      )}
    </div>
  );
};

export default CalorieCharts;
